export const blockIconsSocialWavingHandNew = (
	<span className='material-symbols-outlined'>waving_hand</span>
);
